import React from "react";
import {
  Wrapper,
  List,
  ListItem,
  Title,
  Description,
  Content,
} from "./index.styled";

const CompaniesList = ({ data }) => {
  return (
    <Wrapper>
      <List className="company-list">
        {data?.companies?.map((item, index) => {
          return (
            <ListItem
              className={[item.icon + " company-item"]}
              key={`companies-list-${index}`}
            >
              <Content>
                <Title>{item.title}</Title>
                <Description>{item.description}</Description>
                <Description>{item.text}</Description>
              </Content>
            </ListItem>
          );
        })}
      </List>
    </Wrapper>
  );
};

export default CompaniesList;
